import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { leaveTeam } from '@/utils/SessionUtils';
import { checkMention } from '@/utils';
import UnreadMessagesProxy from '@/Proxies/UnreadMessagesProxy';
import TeamButton from '@/components/teamSwitcher/teamButton/TeamButton';

class TeamButtonContainer extends Component {
  constructor(props) {
    super(props);
    const { ownerGuid } = props;
    this.unreadMessagesSubscription = UnreadMessagesProxy.subscribe(ownerGuid);
  }

  componentWillUnmount() {
    this.unreadMessagesSubscription.unsubscribe();
  }

  onLeaveTeamClick = sessionId => {
    leaveTeam(sessionId);
  };

  render() {
    const {
      unreadMessageIds,
      allMessages,
      ownerGuid,
      ...allPropsOtherThenSubProxy
    } = this.props;

    const unreadPeerSet = new Set();
    const unreadMutedPeerSet = new Set();

    let hasMention = false;

    Object.values(unreadMessageIds).forEach(peerMsgs =>
      peerMsgs.forEach(messageCacheId => {
        const msg = allMessages[messageCacheId];
        if (msg) {
          hasMention = hasMention || checkMention(msg);
          if (!msg.muted) {
            unreadPeerSet.add(msg.peer.jid);
          } else {
            unreadMutedPeerSet.add(msg.peer.jid);
          }
        }
      })
    );

    return (
      <TeamButton
        {...allPropsOtherThenSubProxy}
        hasMention={hasMention}
        unreadConversationCount={unreadPeerSet.size}
        onLeaveTeamClick={this.onLeaveTeamClick}
        mutedUnreadChatCount={unreadMutedPeerSet.size}
      />
    );
  }
}

TeamButtonContainer.propTypes = {
  index: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  ownerGuid: PropTypes.string.isRequired,
  unreadMessageIds: PropTypes.object.isRequired,
  allMessages: PropTypes.object.isRequired,
};

const mapStateToProps = (state, { ownerGuid }) => {
  const {
    message: {
      unread_messages: { [ownerGuid]: unreadMessageIds },
      all_messages: { [ownerGuid]: allMessages },
    },
  } = state.restricted;

  return {
    unreadMessageIds: unreadMessageIds || {},
    allMessages: allMessages || {},
  };
};

export default connect(
  mapStateToProps,
  null
)(TeamButtonContainer);



// WEBPACK FOOTER //
// ./src/containers/TeamButtonContainer.js